import Heading from "./Heading";

export default Heading;
export type { HeadingAdapterProps, RUICHeadingVariants } from "./Heading.d";
